/* DeleteErrorVeilRenderer.js */

"use strict";
const ButtonControl = require("@gluenetworks/steve_ui_core").Control.Action.Button;

class DeleteErrorVeilRenderer {
    constructor(model) {
        this._model = model;

        this._rootElem = document.createElement("delete-error-gl");
        this._rootElem.component = this._model;
        this._logger = this._model.logger;

        this._titlePanel = document.createElement("h2");
        this._titlePanel.innerHTML = "Delete Error";
        this._titlePanel.classList.add("summary-title");
        this._titlePanel.classList.add("error-title");

        this._summaryPanel = document.createElement("div");
        this._summaryPanel.classList.add("summary");

        let summaryLabel = document.createElement("span");
        summaryLabel.innerText = this._model.errorHead;
        this._summaryPanel.appendChild(summaryLabel);

        this._errorLabel = document.createElement("div");
        this._errorLabel.classList.add("error-label");
        this._errorLabel.innerHTML = "Error details:";

        this._errorList = document.createElement("div");
        this._errorList.classList.add("error-list");

        this._errorPanel = document.createElement("div");
        this._errorPanel.classList.add("delete-errors");
        this._errorPanel.appendChild(this._errorList);

        this._buttonBar = document.createElement("div");
        this._buttonBar.classList.add("veil-buttons");

        this._okButton = new ButtonControl({
            label: "OK",
            darkTheme: true,
        });

        this._registerListeners();
    }
    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/

    _registerListeners() {
        this._okButton.on("UserClick", (this._onOkClick = this._onOkClick.bind(this)));
    }

    _unregisterListeners() {
        this._okButton.removeAllListeners("UserClick");
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/

    /* jshint ignore:start */
    shutdown() {
        this._unregisterListeners();
        let promArr = [this._okButton.shutdown()];
        return Promise.all(promArr).then(
            () => {
                this._rootElem.remove();
                this._rootElem = undefined;
                this._rootElem = undefined;
                this._logger = undefined;
                this._titlePanel = undefined;
                this._summaryPanel = undefined;
                this._errorLabel = undefined;
                this._errorList = undefined;
                this._errorPanel = undefined;
                this._buttonBar = undefined;
                this._okButton = undefined;
            },
            (err) => {
                this._logger.warn({error: err}, "DeleteErrorVeilRenderer.shutdown() error.");
            }
        );
    }
    /* jshint ignore:end */

    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        return new Promise((resolve /*,reject*/) => {
            if (!this._rootElem.hasChildNodes()) {
                this._rootElem.appendChild(this._titlePanel);
                this._rootElem.appendChild(this._summaryPanel);
                this._rootElem.appendChild(this._errorLabel);
                this._rootElem.appendChild(this._errorPanel);
                this._rootElem.appendChild(this._buttonBar);
                this._buttonBar.appendChild(this._okButton.renderer.rootElement);
                this._displayErrors();
            }
            resolve();
        });
    }
    get rootElement() {
        return this.getRootElement();
    }
    getRootElement() {
        return this._rootElem;
    }
    get model() {
        return this.getModel();
    }
    getModel() {
        return this._model;
    }
    /*******************************************/
    /* END COMPONENT RENDERER METHODS          */
    /* START PRIVATE RENDER METHODS            */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE RENDER METHODS              */
    /* START HANDLER METHODS                   */
    /*******************************************/

    _onOkClick() {
        this._model.sendOk();
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE API METHODS               */
    /*******************************************/

    _displayErrors() {
        const deleteErrors = this._model.deleteErrors;

        while (this._errorList.firstChild) {
            this._errorList.firstChild.remove();
        }

        deleteErrors.forEach((deleteError) => {
            let errorMsg = document.createElement("div");
            errorMsg.innerText = deleteError;
            errorMsg.classList.add("error-msg");
            this._errorList.appendChild(errorMsg);
        });
    }

    /*******************************************/
    /*  END PRIVATE API METHODS                */
    /*******************************************/
}
module.exports = DeleteErrorVeilRenderer;
